export default __webpack_public_path__ + "static/media/visa_card.7b27b492.svg";